(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var slider = document.querySelectorAll('[data-slider] .testimonial-slide');
  var dots = document.querySelectorAll('.testimonial-dot');
  if(!slider || slider.length === 0) return;

  function goto(index) {
    slider.forEach(function(s){ s.classList.remove('is-active'); });
    dots.forEach(function(d){ d.classList.remove('is-active'); d.setAttribute('aria-selected','false'); });
    var s = slider[index];
    var d = dots[index];
    if(s) s.classList.add('is-active');
    if(d) { d.classList.add('is-active'); d.setAttribute('aria-selected','true'); }
  }

  dots.forEach(function(dot){
    dot.addEventListener('click', function(e){
      var i = parseInt(dot.getAttribute('data-dot-index'));
      goto(i);
    });
  });

  /* Optional autoplay - comment out if not wanted */
  var current = 0;
  var slideCount = slider.length;
  if(slideCount > 1){
    setInterval(function(){
      current = (current + 1) % slideCount;
      goto(current);
    }, 5000);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
